import { apiConfig, http } from "@api/base";

const marc21URL = "/marc21";

const parse = async (file) => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await http.post(`${marc21URL}/parse`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response;
};

const validate = async (data) => {
  const response = await http.post(`${marc21URL}/validate`, data);
  return response;
};

export const marc21Api = {
  searchBaseURL: `${apiConfig.baseURL}${marc21URL}`,
  parse,
  validate,
};
